import { Item, Move, MoveLine } from '@conveyr/shared-types';
import { AxiosInstance } from 'axios';
import baseAxios, { fetchPaginatedDataFunction } from '@/helpers/forms/axios';
import { DataFetcherFunction } from '../compiler/types';

export interface ProductionBatchServiceLine {
    serviceUuid: string
    quantity: number
}

export interface ProductionBatch {
    uuid: string
    createdAt: string
    warehouseUuid: string
    merchantUuid: string
    productionFormulaUuid: string | null
    referenceUuid: string | null
    title: string
    billingDescription: string
    serviceLines: ProductionBatchServiceLine[]
    moves: Move<MoveLine, Item>[]
}

export interface CreateProductionBatchRequest {
    warehouseUuid: string
    title: string
    billingDescription?: string
    productionFormulaUuid?: string
    serviceLines?: Array<{
        serviceUuid: string
        quantity: number
    }>
    inputProductLines: Array<{
        productUuid: string
        locationUuid: string
        quantity: number
        note: string | null
    }>
    outputProductLines: Array<{
        productUuid: string
        locationUuid: string
        quantity: number
        note: string | null
    }>
}

export default (axios: AxiosInstance = baseAxios): { fetchProductionBatches: (preRequest?: (uri: URL) => URL) => DataFetcherFunction<ProductionBatch>; createProductionBatch: (data: CreateProductionBatchRequest) => Promise<ProductionBatch>; fetchProductionBatch: (uuid: string) => Promise<ProductionBatch>; deleteProductionBatch: (uuid: string) => Promise<void>; } => ({
    fetchProductionBatches: (preRequest?: (uri: URL) => URL): DataFetcherFunction<ProductionBatch> => fetchPaginatedDataFunction<ProductionBatch>('/api/production-batches', preRequest, axios),

    createProductionBatch: async (data: CreateProductionBatchRequest): Promise<ProductionBatch> => {
        const response = await axios.post<{ data: ProductionBatch }>('/api/production-batches', data);
        return response.data.data;
    },

    fetchProductionBatch: async (uuid: string): Promise<ProductionBatch> => {
        const response = await axios.get<{ data: ProductionBatch }>(`/api/production-batches/${uuid}`);
        return response.data.data;
    },

    deleteProductionBatch: async (uuid: string): Promise<void> => {
        await axios.delete(`/api/production-batches/${uuid}`);
    },
});
